<template>
    <div class="d-flex">
        <div class="login-bg"></div>
        <div class="login-container">
            <div class="login-container__wrapper">
                <a href="https://ivanhoe.io/" title="Go back to Ivanhoe.io">
                    <img 
                        class="login-container__logo" 
                        src="https://ivanhoe.io/assets/images/logo/ivanhoe.io-logo.svg" 
                        alt="ivanhoe.io Logo"
                    />
                </a>
                <h1 class="login-container__title">
                    Request Reset Password
                </h1>
                <p v-if="errors.length">
                    <b class="text-danger" v-for="error in errors">{{ error }}</b>
                </p>
                <d-form v-if="! isSendRequest" class="login-form" @submit.prevent="handle">
                    <label for="email" class="mb-1 d-block login-form__label">
                        Email
                    </label>
                    <input
                        id="email"
                        required
                        type="email" 
                        placeholder="Email"
                        v-model="email"
                        class="form-control d-block w-100 login-input"
                    />
                    <div class="d-flex d-md-block justify-content-between align-items-center mt-2">
                        <input value="Request Reset Password" type="submit" class="btn btn--primary d-md-block w-md-100">
                    </div>
                </d-form>
                <div v-else>
                    <p class="alert alert-success">Please, check your email and confirm request for reset password!</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>    
    import { AuthService } from '@/main'

    export default {
        data() {
            return {
                email: null,
                isSendRequest: false,
                errors: []
            };
        },
        methods: {
            async handle() {
                try {
                    await AuthService.resetPasswordRequest(this.email)
                    this.isSendRequest = true
                } catch(e) {
                    this.errors = [];
                    this.errors.push(e.networkError.result.errors[0].message);
                }
            }
        }
    };
</script>